import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const NextEpisodeContainer = styled.div<React.CSSProperties>`
  bottom: ${172 * Screen.widthRatio}px;
  display: flex;
  right: ${445 * Screen.widthRatio}px;
  position: absolute;
  z-index: 130; // Place next episode on top of the pilot and before the pause ad
`;

export default NextEpisodeContainer;
